<template>
  <div class="container">
    <h4 class="title is-4">Automations Log</h4>
    <div class="container has-text-left">
      <div class="block">
        <b-field>
          <b-radio-button
              v-for="timeFrame in automationsLogTimeFrames"
              :key="timeFrame.tag"
              :value="timeFrame.tag"
              :native-value="timeFrame.tag"
              v-model="timeFrameTag"
          >{{timeFrame.tag}}
          </b-radio-button>
          <div style="margin-left: 1rem;">
            <b-button type="is-warning" @click="handleViewLog">View</b-button>
          </div>
        </b-field>
      </div>
      <hr/>
    </div>
    <b-table
        v-if="tableData.length > 0"
        :narrowed="true"
        :striped="true"
        :data="tableData"
    >
      <template slot-scope="props">
        <b-table-column field="num" class="is-hidden-mobile" numeric>{{props.row.num}}</b-table-column>
        <b-table-column field="automationName" label="Automation">
          <router-link :to="{path: '/configure/automations/' + props.row.automationId}">
            {{props.row.automationName}}
          </router-link>
        </b-table-column>
        <b-table-column field="runId" label="Run ID" class="is-hidden-mobile">{{props.row.runId}}</b-table-column>
        <b-table-column field="timestamp" label="Time" centered>{{props.row.localTime}}</b-table-column>
        <b-table-column field="hftResult" label="Result" class="is-hidden-mobile" centered>{{props.row.hftResult}}
        </b-table-column>
      </template>
    </b-table>
    <div v-else>No log data, yet.</div>
  </div>
</template>

<script>
  import {mapGetters, mapMutations, mapActions} from 'vuex';
  import BTable from "buefy/src/components/table/Table";
  import BTableColumn from "buefy/src/components/table/TableColumn";
  import {formatTime} from '../utils/utils.js';
  import BButton from "buefy/src/components/button/Button";
  import BField from "buefy/src/components/field/Field";
  import BRadioButton from "buefy/src/components/radio/RadioButton";

  export default {
    components: {
      BRadioButton,
      BField,
      BButton,
      BTableColumn,
      BTable
    },
    name: "screenautomationslog",
    data() {
      return {
        timeFrameTag: null
      };
    },
    watch: {
      timeFrameTag(value) {
        this['SET_AUTOMATIONS_LOG_FILTER_TIME_FRAME_TAG'](value);
      }
    },
    computed: {
      ...mapGetters('log', ['automationsLog', 'automationsLogFilters', 'automationsLogTimeFrames']),
      tableData() {
        const ret = [];

        let num = 0;
        this.automationsLog.forEach(item => {
          num++;

          const hftResult = parseInt(item.status, 10) !== 0 ? item.result : 'OK';

          ret.push({
            ...item,
            localTime: formatTime(item['timestamp']),
            automationId: item['automation_id'],
            automationName: item['automation_name'],
            runId: item['run_id'],
            hftResult: hftResult,
            num
          });
        });

        return ret;
      }
    },
    methods: {
      ...mapMutations('log', ['SET_AUTOMATIONS_LOG_FILTER_TIME_FRAME_TAG']),
      ...mapActions('log', ['fetchAutomationsLog']),
      handleViewLog() {
        this.fetchAutomationsLog();
      }
    },
    mounted() {
      if (this.automationsLogTimeFrames.length > 0) {
        this.timeFrameTag = this.automationsLogFilters.timeFrameTag;
      }
    }
  }
</script>

<style scoped>

</style>